import request from '@/utils/request.js'

/***流量池管理列表***/
export function getFluxPoolMgtList(data){
    return request({
        url: 'simPool/warn/manager/list',
        method: 'post',
        data
    })
}

/***新增流量池***/
export function addFluxPool(data){
    return request({
        url: 'simPool/warn/insert',
        method: 'post',
        data
    })
}
/***编辑流量池***/
export function editFluxPool(data){
    return request({
        url: 'simPool/warn/update',
        method: 'post',
        data
    })
}
/***分配流量池列表***/
export function deltePool(data){
    return request({
        url: 'simPool/warn/delete',
        method: 'post',
        data
    })
}
